import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <footer className="main-footer" style={{ background: "#ffffff",
        padding: "10px 20px",
        borderTop: "1px solid #dee2e6",
        textAlign: "center", }}>
        <strong>Copyright &copy; 2025 <span>Solutama</span>.</strong>
        All rights reserved.
        <div className="float-right d-none d-sm-inline-block">
          <b>Version</b> 1.0.0
        </div>
      </footer>
    );
  }
}
